import { AgentStep, Messages, StreamAction } from "@/types";
import { Fragment } from "react";
import { MessageFeedback } from "./message-feedback";
import { Message, extractThinking, hasOpenThinkTag } from "./message";
import { StepsContainer } from "./agent-steps/steps-container";
import { StreamActions } from "./stream-actions/stream-actions";
import { ThinkingBlock } from "./thinking-block";
import { TypingText } from "@/components/ui/styling-text";
import { useTranslation } from "react-i18next";
export const RenderConversation = ({
  messages,
  scrollRef,
  contentRef,
  agentSteps,
  streamActions,
  mode,
  isPlanning,
  isThinking,
}: {
  messages: Messages;
  scrollRef: any;
  contentRef: any;
  isPlanning: boolean;
  isThinking?: boolean;
  agentSteps: {
    currentStep: number;
    steps: Array<AgentStep>;
  };
  streamActions?: Array<StreamAction>;
  mode?: string;
}) => {
  const { t } = useTranslation();
  const showActions = mode === "agentic";
  const lastMessage = messages[messages.length - 1];
  const lastAssistantContent =
    lastMessage?.role === "assistant" && typeof lastMessage.content === "string"
      ? lastMessage.content
      : "";
  const lastHasThinking = lastAssistantContent.includes("<think>");

  return (
    <div
      style={{
        maxWidth: "1000px",
        margin: "0 auto",
        scrollbarColor: "var(--primary) transparent",
        scrollbarWidth: "none",
      }}
      // resize="smooth" initial="smooth"
      className="flex-1 py-3 px-2 sm:py-5 sm:px-4 overflow-scroll overflow-x-hidden flex flex-col h-full w-full gap-4"
      ref={scrollRef}
    >
      <div ref={contentRef} className="flex flex-col gap-4 text-foreground">
        {messages.map((message, index) => {
          const isLast = index === messages.length - 1;
          const isAssistant = message.role === "assistant";
          const thinkingText =
            isLast && isAssistant ? extractThinking(lastAssistantContent) : "";
          return (
            <Fragment key={message.id}>
              {isLast && isAssistant && (
                <>
                  {thinkingText && (
                    <ThinkingBlock
                      text={thinkingText}
                      isActive={hasOpenThinkTag(lastAssistantContent)}
                    />
                  )}
                  <StepsContainer
                    agentSteps={agentSteps}
                    isPlanning={isPlanning}
                    isFinished={!!message.content}
                  />
                  {showActions && <StreamActions actions={streamActions} />}
                </>
              )}
              {isAssistant ? (
                <div className="flex min-w-0 flex-col gap-1">
                  <Message
                    message={message.content}
                    {...message}
                    hideThinking={isLast}
                  />
                  {!message.is_streaming && !message.id.startsWith("temp-") && (
                    <MessageFeedback
                      messageId={message.id}
                      conversationId={message.conversation_id}
                      streaming={message.is_streaming}
                      initialFeedback={message.feedback ?? null}
                    />
                  )}
                </div>
              ) : (
                <Message message={message.content} {...message} />
              )}
            </Fragment>
          );
        })}
        {(messages.length === 0 ||
          messages[messages.length - 1].role !== "assistant") && (
          <>
            <StepsContainer
              agentSteps={agentSteps}
              isPlanning={isPlanning}
              isFinished={false}
            />
            {showActions && <StreamActions actions={streamActions} />}
          </>
        )}
        {isThinking && !isPlanning && !lastHasThinking && (
          <div className="px-1">
            <TypingText text={t("playground.thinking")} />
          </div>
        )}
      </div>
    </div>
  );
};
